import React from 'react';

import { BRAND_COLORS } from 'brand-guidelines/colors';

interface LockSvgProps {
  color?: string;
}

export const LockSvg = ({ color = BRAND_COLORS.darkGray }: LockSvgProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none">
    <path
      fill={color}
      d="M15 6.667h-.833V5C14.167 2.7 12.3.833 10 .833A4.168 4.168 0 0 0 5.833 5v1.667H5c-.917 0-1.667.75-1.667 1.666v8.334c0 .916.75 1.666 1.667 1.666h10c.917 0 1.667-.75 1.667-1.666V8.333c0-.916-.75-1.666-1.667-1.666Zm-5 7.5c-.917 0-1.667-.75-1.667-1.667s.75-1.667 1.667-1.667 1.667.75 1.667 1.667-.75 1.667-1.667 1.667Zm-2.5-7.5V5c0-1.383 1.117-2.5 2.5-2.5s2.5 1.117 2.5 2.5v1.667h-5Z"
    />
  </svg>
);

